import useBookmarks from '@snowit/hookspannello/useBookmarks';
import useLanguage from '@snowit/system/useLanguage';
import { Flex, Toggle, Typo } from '@snowit/ui/index';

const QuickJumpSwitch = () => {
  const { viewOnlyBookmarks, toggleView } = useBookmarks();
  const { t } = useLanguage();

  return (
    <Flex align={'center'} justify={'space-between'} gap={1}>
      <Typo size={'sm'} text={t('lzy.label.view_only_bookmarked')} />
      <Toggle name={'view_only_bookmarked'} onClick={toggleView} value={viewOnlyBookmarks} />
    </Flex>
  );
};

export default QuickJumpSwitch;
